import { render, staticRenderFns } from "./TraspasoCoCa.vue?vue&type=template&id=256365a0&"
import script from "./TraspasoCoCa.vue?vue&type=script&lang=js&"
export * from "./TraspasoCoCa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports